import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UpdateDto } from '@dto';
import { GenericOldService } from './generic-old.service';

@Injectable({ providedIn: 'root' })
export class LatestUpdateService {
  updates$: Subject<UpdateDto[]>;

  constructor(private resourceService: GenericOldService<UpdateDto>) {
    this.updates$ = new Subject<UpdateDto[]>();
  }

  setUpdates(): Observable<UpdateDto[]> {
    return this.resourceService.getList('updates/latest').pipe(tap(updates => this.updates$.next(updates)));
  }
}
